import { useCallback, useEffect } from 'react'
import JSZip from 'jszip'
import { saveAs } from 'file-saver'
import API from "@api/api";
import { useState } from 'react'
import {  BATCH_IMAGES_TYPE } from "@utils/CONST"

export default function usePickedImageDownload(projectId, projectName) {
    const [downLoading, setDownLoading] = useState(false)
    function sanitizeFileName(name = '') {
        return name
            .replace(/[\\/:*?"<>|]/g, '_') // Windows 不允许的字符
            .replace(/\s+/g, '_')          // 空格替换为下划线
            .replace(/[^\w\u4e00-\u9fa5.-]/g, '_') // 其余非字母数字、中文、点或横线的字符替换掉
            .slice(0, 100)                 // 限制长度，避免路径过长
    }


    const projectTypeText = useCallback((projectType) => {
        return projectType === BATCH_IMAGES_TYPE.TRYON_BATCH ? 'AI试衣' :
            projectType === BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH ? '换模特' :
                projectType === BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH ? '换背景' :
                    projectType === BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH ? '商品智能堆叠' :
                        ''
    }, [])



    const handleDownload = useCallback(async () => {
        if (!projectId) {
            console.warn('缺少 projectId，无法下载')
            return
        }

        try {
            const res = await API.getPickedImageList({
                projectId,
                picked: true,
            })

            if (res.code !== 0 || !res.data?.length) {
                console.warn('没有可下载的图片')
                return
            }
            setDownLoading(true)

            const pickedList = res.data
            const zip = new JSZip()

            // 相同 skuId 放入同一组
            const grouped = pickedList.reduce((acc, item) => {
                const skuId = item.skuId
                if (!acc[skuId]) acc[skuId] = []
                acc[skuId].push(item)
                return acc
            }, {})

            const skuIds = Object.keys(grouped)
            let index = 0

            // 遍历每组进行下载
            for (const skuId of skuIds) {
                const group = grouped[skuId]
                const folderName = `${sanitizeFileName(group[0]?.skuName || 'unknown')}`
                const skuFolder = zip.folder(folderName)

                for (let i = 0; i < group.length; i++) {
                    const urls = group[i].results || []
                    if (!Array.isArray(urls) && group[i].result) {
                        urls.push(group[i].result)
                    }

                    // 遍历所有URL进行下载
                    for (let j = 0; j < urls.length; j++) {
                        const url = urls[j]
                        if (!url) continue

                        try {
                            const response = await fetch(url)
                            const blob = await response.blob()
                            const ext = url.split('.').pop().split('?')[0]
                            const fileName = urls.length > 1
                                ? `${sanitizeFileName(group[i]?.skuName || 'unknown')}_${sanitizeFileName(group[i]?.taskSerial)}_${j + 1}.${ext}`
                                : `${sanitizeFileName(group[i]?.skuName || 'unknown')}_${sanitizeFileName(group[i]?.taskSerial)}.${ext}`
                            skuFolder.file(fileName, blob)
                        } catch (err) {
                            console.error('图片下载失败:', url, err)
                        }

                        index++
                    }
                }
            }
            const getProjectName = await API.batchListSkuCoverList({ projectId: projectId })
            const projectName = getProjectName?.data?.projectName || ''
            const projectType = getProjectName?.data?.projectType || ''
            const zipBlob = await zip.generateAsync({ type: 'blob' })
            saveAs(zipBlob, `PSAI_${projectTypeText(projectType)}${projectName}.zip`)
            console.log('下载完成')
            setDownLoading(false)

        } catch (error) {
            console.error('下载失败:', error)
            setDownLoading(false)
        }
    }, [projectId, projectName])

    return { handleDownload, downLoading }
}
